<template>

  <div>
    <img class="mx-auto h-96 w-center" src="@//assets/icons/Slagboom-ondergrond.svg" />
    <card-title>Welke ondergrond heeft de locatie waar<br /> de slagboom geplaatst wordt?</card-title>

    <fieldset class="flex flex-col my-3" id="lengte">
      <label v-for="option in this.pages[3]['options']" :key="option.price" :for="option.id"
        class="inline-flex items-center mt-3">
        <input @click="setValueChild('stap-4', option.price, option.title)" :checked="option.selected == true"
          :id="option.id" type="radio" value="20" name="group2" class="
            form-radio
            h-5
            w-5
            text-primary
            checked:bg-primary checked:border-4
            bg-transparent
            border-primary border-2
          " /><span class="ml-2">{{ option.title }}</span>
      </label>
    </fieldset>


    <btn-group-bottom previous="stap-3" next="stap-5" :current="this.pages[3]['slug']"
      @InlineButtonClickHandler="InlineButtonClickHandler" />

  </div>

</template>

<script>
export default {
  name: 'Stap4',
  props: {
    pages: Array,
    totalPrice: Number,
  },
  methods: {
    addChild(i) { this.$emit("add", i) },
    removeChild(i) { this.$emit("remove", i) },
    setValueChild(key, value, title) {
      this.$emit("setValue", key, value, title);
    },
    InlineButtonClickHandler(current) {
      this.$emit("InlineButtonClickHandler", current);
    },
  },
  mounted: function () {
  },
  inheritAttrs: false, // disable 'non-props' warning
};



</script>
